export function headerMenu() {
    let headerMenus = document.querySelectorAll('[data-headerMenu]');

    headerMenus.forEach(headerMenu => {
        let toggleBtn = headerMenu.querySelector('[data-headerMenuToggle]');
        let open = false;

        function toggleMenu() {
            if (open == false) {
                headerMenu.classList.add('_active');
                open = true;
                toggleBtn.setAttribute('aria-expanded', open);
            } else {
                headerMenu.classList.remove('_active');
                open = false;
                toggleBtn.setAttribute('aria-expanded', open);
            }
        }

        toggleBtn.addEventListener('click', evt => toggleMenu());
    });
}
